import React, { Component } from 'react';
import ListItem from '@material-ui/core/ListItem';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
// import CircularProgress from '@material-ui/core/CircularProgress';
import _ from 'lodash';
import cx from 'classnames';
import { MyPATLink } from '../../common';
import { getDateStatus, getGoals, getDate, getBatches, getIntructors, getBatchesKeys } from "../components/CourseDetail/commonFunction"
import { styles } from '../styling/component/CourseMainPageCard'

import {
  WithStyles,
  createStyles,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';
import MyPatCircleProgress from '../../common/MyPatCircleProgress';

interface WithContentProps extends WithStyles<typeof styles> {
  cardDetails: any;
  cardFlag: string;
  batchesData: any[];
  handleBatchClick: Function,
}


const CourseMainPageCard = (props: WithContentProps) => {
  const {
    classes,
    cardDetails,
    batchesData,
    cardFlag,
    handleBatchClick
  } = props;

  let value = cardDetails;

  let colorArr: { [index: string]: string } = {};

  colorArr = {
    "PUBLISHED0": "#2196F3",
    "LIVE0": "#7DCA36",
    "PAST0": "#C6C6C6",
    "DRAFT0": "#F35821",
    "DRAFT1": "#F39221",
    "DRAFT2": "#F0E617"
  }

  var getStatus: any = getDateStatus(value.startDate, value.expiryDate, value.status, value.draftCompletionPercentage) || "DRAFT0"

  let _getStatusCheck = getStatus.substring(0, getStatus.length - 1).toLocaleUpperCase();

  let _color = colorArr[getStatus.toString()];

  const batchKeys = getBatchesKeys(value.setting);
  let _getUrl:boolean= (window.location.href).indexOf("course/detail") > -1 ? false : true;

  if(value.draftCompletionPercentage){
      if(value.draftCompletionPercentage == 0){
        var percentage = value.draftCompletionPercentage + 0;
      }
      else if(value.draftCompletionPercentage > 100){
        var percentage:any = 100;
      }
      else{
        var percentage = value.draftCompletionPercentage
      }
  }
 

  return (
    <>
      <Grid item xs={1}>
      {
        value.courseIcon ? <img style={{width:"80px",height:"80px",borderRadius:"50%",border:"5px solid slategray"}} src={value.courseIcon} alt="course_img"></img> :
        <MyPatCircleProgress percentage={percentage} color={_color} innerText={(value.name).toLocaleUpperCase().substring(0, 1)} />
      }
                
                <Grid container alignItems="center" justify="center" className={classes.textBar}>
                
                { 
                  _getStatusCheck === "DRAFT"
                  ?
                    <>
                    <span className={classes.percentage}>
                        {value.draftCompletionPercentage + "%" }
                    </span>
                      <span className={classes.subHead}>
                          &nbsp;Draft Progress
                      </span> 
                    </>
                  :
                    _getStatusCheck   
                }
                
                
                </Grid>
      </Grid>
      <Grid item xs={12}  >
        <Grid container className={classes.leftDisplay}>
          <Grid item xs={12}>
            <Typography variant="body1" className={cx(classes.textEllipsis)}>{value.name}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" className={cx(classes.textEllipsis)}>{getGoals(value.goals).join(", ")}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" className={classes.subTitle}><b>Course Duration : </b>{getDate(value.startDate, value.expiryDate)}</Typography>
          </Grid>

          {
            cardFlag !== ""
              ?
              <Grid item xs={12}>
                <Typography variant="body2" className={classes.subTitle}><b> Instructors: {getIntructors(batchesData).join(', ')} </b></Typography>
              </Grid>
              : cardDetails && cardDetails.setting.batches && cardDetails.setting.batches.length > 0  ?
              <Grid item xs={12}>
                <Typography variant="body2" className={classes.subTitle} >
                  <b> Batches: <span>
                    {
                      getBatches(value.setting).map((batch:any, index:number) => (
                        <span className={classes.commaSeparation} onClick={() => _getUrl ? handleBatchClick(batchKeys[index], batch) : ""}>{batch}</span>
                      ))
                    }
                    </span>
                  </b>
                </Typography>
              </Grid> :''
          }

        </Grid>

      </Grid>
    </>
  )
}

export default withStyles(styles)(CourseMainPageCard);
